<mat-spinner *ngIf="loading"></mat-spinner>
<div *ngIf="!loading" class="edit-actions">
    <mat-spinner *ngIf="loadingAction" [diameter]="20"></mat-spinner>
    <button *ngIf="!loadingAction" matTooltip="Cancelar" (click)="cancel()" mat-icon-button class="card-inline">
    <mat-icon>clear</mat-icon>
  </button>
    <button *ngIf="!loadingAction" matTooltip="Recibir" (click)="receive()" mat-icon-button class="card-inline">
    <mat-icon>flag</mat-icon>
  </button>
</div>
<mat-tab-group (selectedIndexChange)="selectedIndexChange($event)" #tabGroup>
    <mat-tab label="Lote">
        <div class="card-base  margin-botton-medium">
            <div class="card-content-wizard">
                <div class="card-container mat-elevation-z1">
                    <app-send-study-report-logistics-detail [hidden]="loading" #sendStudyReportLogisticsDetail></app-send-study-report-logistics-detail>
                </div>
            </div>
        </div>
    </mat-tab>
    <mat-tab label="Informes">
        <div class="card-base  margin-botton-medium">
            <div class="card-content-wizard">
                <div class="card-container mat-elevation-z1">
                    <app-receive-study-report-logistics-item [hidden]="loading" #receiveStudyReportLogisticsItem></app-receive-study-report-logistics-item>
                </div>
            </div>
        </div>
    </mat-tab>
</mat-tab-group>